import React from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import styles from "./Reset.module.scss";

const ResetPassword = ({ isOpen, toggle }) => {
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.mainheading}>Reset Password</div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Old Password"
            placeholder="•••••••••••"
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="oldPassowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
          />
        </div>

        <div className={styles.fieldWrapper}>
          <GenericInput
            label="New Password"
            placeholder="••••••••••• "
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="newPassowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
            className={styles.generic}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Repeat Password"
            placeholder="•••••••••••"
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="repeatPassowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
            className={styles.generic}
          />
        </div>
        <div className={styles.buttonWrapper}>
          <GenericButton title={"Update"} />
        </div>
      </GenericModal>
    </>
  );
};

export default ResetPassword;
